module.exports = __webpack_public_path__ + "img/7_no.fa79b79d.svg";